import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FAMILY_PRIMARY_TAG_LABEL, FAMILY_TAG_LABEL } from '../../utils/family-tags.util';

/**
 * Family plan tags (CWS-1582 §8): the "Family plan" pill, and "Primary" beside it on the primary.
 * Presentational only; the rule for which tags a row carries is `familyTagsOf`. The pills use the
 * global `.family-tag` style.
 *
 * @selector app-family-tags
 * @input isFamily - The membership belongs to a family plan.
 * @input isPrimary - It is the primary of that family; shown only together with `isFamily`.
 */
@Component({
  selector: 'app-family-tags',
  standalone: true,
  templateUrl: './family-tags.component.html',
  host: { class: 'family-tags' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FamilyTagsComponent {
  @Input() isFamily = false;
  @Input() isPrimary = false;

  readonly familyLabel = FAMILY_TAG_LABEL;
  readonly primaryLabel = FAMILY_PRIMARY_TAG_LABEL;
}
